<template>
  <main class="flex">
    <nav class="navbar"></nav>
    <section class="warning flex">
      <h1>ATTENTION!!!</h1>
      <h2>
        Internet Explorer and Edge no longer supports the latest website
        technology, please use alternative browser such as
      </h2>
      <div class="flex">
        <h2>
          <a href="https://www.google.com/chrome/">Chrome</a>
        </h2>
        <h2 class="separator">or</h2>
        <h2>
          <a href="https://www.mozilla.org/en-US/firefox/new/">Firefox</a>
        </h2>
      </div>
    </section>
  </main>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
main.flex {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  flex-direction: column;
}
.flex {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  nav {
    height: 30vh;
    width: 100%;
    background-image: var(--congress-icon-city-center);
    background-repeat: no-repeat;
    background-size: 100%;
  }

  .warning.flex {
    flex-direction: column;
    height: 70vh;
    width: 60vw;

    a {
      // text-decoration: none;
      color: var(--congress-color);
    }

    a:hover {
      color: var(--congress-color-hover);
    }
    h1,
    h2 {
      font-family: "Source Sans Pro", sans-serif;
      margin: 10px;
    }
    h1 {
      &::before {
        content: url("../assets/icons8-alta-prioridad-96.png");
        padding-right: 10px;
        vertical-align: -100%;
      }
    }
    .separator {
      padding: 0 2em;
      margin: 0;
    }
  }

  @media only screen and (max-width: 768px) {
    nav {
      height: 15vh;
    }
    .warning.flex {
      height: 50vh;
    }
  }
}
</style>
